import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/TopEarn/GET';

export const TOP_EARN_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const TOP_EARN_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
